








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import { getDefaultAloContact, AloContact } from '@/models/alo/AloContact';

@Component({
  name: 'ReadContent',    
   props: {
    contact:{      
      default:getDefaultAloContact()
    },
    loading:{
      type:Boolean,
      default:false
    }
  }
})
export default class ReadContent extends Vue {
  private contact!:AloContact
  private loading!:boolean

}
